"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStructuredLogMessage = exports.Runtime = void 0;
var Shape_1 = __importDefault(require("./Shape"));
var Runtime = /** @class */ (function () {
    function Runtime(instance) {
        this.instance = instance;
    }
    Runtime.load = function (wasm, imports) {
        return __awaiter(this, void 0, void 0, function () {
            var memory, _a, hostFunctions, finaliseModels, instance, exports;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = importsToHostFunctions(imports, function () { return memory; }), hostFunctions = _a.hostFunctions, finaliseModels = _a.finaliseModels;
                        return [4 /*yield*/, WebAssembly.instantiate(wasm, hostFunctions)];
                    case 1:
                        instance = (_b.sent()).instance;
                        exports = instance.exports;
                        if (!isRuneExports(exports)) {
                            throw new Error("Invalid Rune exports");
                        }
                        memory = exports.memory;
                        exports._manifest();
                        // now we've asked for all the models to be loaded, let's wait until
                        // they are done before continuing
                        return [4 /*yield*/, finaliseModels()];
                    case 2:
                        // now we've asked for all the models to be loaded, let's wait until
                        // they are done before continuing
                        _b.sent();
                        return [2 /*return*/, new Runtime(instance)];
                }
            });
        });
    };
    Runtime.prototype.manifest = function () {
        return this.exports._manifest();
    };
    Runtime.prototype.call = function () {
        this.exports._call(0, 0, 0);
    };
    Object.defineProperty(Runtime.prototype, "exports", {
        get: function () {
            // Note: checked inside Runtime.load() and exports will never change.
            var exports = this.instance.exports;
            if (isRuneExports(exports)) {
                return exports;
            }
            else {
                throw Error();
            }
        },
        enumerable: false,
        configurable: true
    });
    return Runtime;
}());
exports.Runtime = Runtime;
/**
 * Generate a bunch of host functions backed by the supplied @param imports.
 */
function importsToHostFunctions(imports, getMemory) {
    var memory = function () {
        var m = getMemory();
        if (!m)
            throw new Error("WebAssembly memory wasn't initialized");
        return new Uint8Array(m.buffer);
    };
    var ids = counter();
    var outputs = {};
    var capabilities = {};
    var pendingModels = [];
    var models = {};
    var modelsDescription = {};
    var utf8 = new TextDecoder();
    var decoder = new TextDecoder("utf8");
    // Annoyingly, this needs to be an object literal instead of a class.
    var env = {
        _debug: function (msg, len) {
            var raw = memory().subarray(msg, msg + len);
            var decoded = utf8.decode(raw);
            var parsed = tryParseJSON(decoded);
            function tryParseJSON(input) {
                try {
                    return JSON.parse(input);
                }
                catch (_a) {
                    return;
                }
            }
            if (isStructuredLogMessage(parsed)) {
                imports.log(parsed);
                if (parsed.level == "ERROR") {
                    // Translate all errors inside the Rune into exceptions,
                    // aborting execution.
                    throw new Error(parsed.message);
                }
            }
            else {
                imports.log(decoded);
            }
        },
        request_output: function (type) {
            var output = imports.createOutput(type);
            var id = ids();
            outputs[id] = output;
            return id;
        },
        consume_output: function (id, buffer, len) {
            var output = outputs[id];
            if (output) {
                var data = memory().subarray(buffer, buffer + len);
                output.consume(data);
            }
            else {
                throw new Error("Invalid output");
            }
        },
        request_capability: function (type) {
            var capability = imports.createCapability(type);
            var id = ids();
            capabilities[id] = capability;
            return id;
        },
        request_capability_set_param: function (id, keyPtr, keyLength, valuePtr, valueLength, valueType) {
            var keyBytes = memory().subarray(keyPtr, keyPtr + keyLength);
            var key = decoder.decode(keyBytes);
            var bytes = memory().subarray(valuePtr, valuePtr + valueLength).slice(0);
            var value = decodeValue(valueType, bytes);
            var capability = capabilities[id];
            if (!capability) {
                throw new Error("Tried to set \"".concat(key, "\" to ").concat(value, " but capability ").concat(id, " doesn't exist"));
            }
            capability.setParameter(key, value);
        },
        request_provider_response: function (buffer, len, id) {
            var cap = capabilities[id];
            if (!cap) {
                throw new Error("Invalid capability");
            }
            var dest = memory().subarray(buffer, buffer + len);
            cap.generate(dest);
        },
        rune_model_load: function (mimetype, mimetype_len, model, model_len, input_descriptors, input_len, output_descriptors, output_len) {
            var mime = decoder.decode(memory().subarray(mimetype, mimetype + mimetype_len));
            var model_data = memory().subarray(model, model + model_len);
            //inputs
            var o = memory().subarray(input_descriptors, input_descriptors + 8 * input_len);
            var inputs = [];
            for (var i = 0; i < input_len; i++) {
                var inputs_pointer = new Uint32Array(new Uint8Array([o[i * 8], o[i * 8 + 1], o[i * 8 + 2], o[i * 8 + 3]]).buffer)[0];
                var inputs_length = new Uint32Array(new Uint8Array([o[i * 8 + 4], o[i * 8 + 5], o[i * 8 + 6], o[i * 8 + 7]]).buffer)[0];
                var inputs_string = decoder.decode(memory().subarray(inputs_pointer, inputs_pointer + inputs_length));
                inputs.push({ "dimensions": inputs_string });
            }
            //outputs
            o = memory().subarray(output_descriptors, output_descriptors + 8 * output_len);
            var outputs = [];
            for (var i = 0; i < output_len; i++) {
                var outputs_pointer = new Uint32Array(new Uint8Array([o[i * 8], o[i * 8 + 1], o[i * 8 + 2], o[i * 8 + 3]]).buffer)[0];
                var outputs_length = new Uint32Array(new Uint8Array([o[i * 8 + 4], o[i * 8 + 5], o[i * 8 + 6], o[i * 8 + 7]]).buffer)[0];
                var outputs_string = decoder.decode(memory().subarray(outputs_pointer, outputs_pointer + outputs_length));
                outputs.push({ "dimensions": outputs_string });
            }
            var pending = imports.createModel(mime, model_data);
            var id = ids();
            pendingModels.push(pending.then(function (model) { return [id, model]; }));
            modelsDescription[id] = { id: id, inputs: inputs, outputs: outputs, "modelSize": model_len };
            return id;
        },
        rune_model_infer: function (id, inputs, outputs) {
            return __awaiter(this, void 0, void 0, function () {
                var model, modelsDes, inputArray, inputDimensions, i, dimensions, o, pointer, outputArray, outputDimensions, i, dimensions, o, pointer;
                return __generator(this, function (_a) {
                    model = models[id];
                    modelsDes = modelsDescription[id];
                    inputArray = [];
                    inputDimensions = [];
                    for (i = 0; i < modelsDes.inputs.length; i++) {
                        dimensions = Shape_1.default.parse(modelsDes.inputs[i].dimensions);
                        o = memory().subarray(inputs + i * 4, inputs + 4 + i * 4);
                        pointer = new Uint32Array(new Uint8Array([o[0], o[1], o[2], o[3]]).buffer)[0];
                        inputArray.push(memory().subarray(pointer, pointer + dimensions.byteSize));
                        inputDimensions.push(dimensions);
                    }
                    outputArray = [];
                    outputDimensions = [];
                    for (i = 0; i < modelsDes.outputs.length; i++) {
                        dimensions = Shape_1.default.parse(modelsDes.outputs[i].dimensions);
                        o = memory().subarray(outputs + i * 4, outputs + 4 + i * 4);
                        pointer = new Uint32Array(new Uint8Array([o[0], o[1], o[2], o[3]]).buffer)[0];
                        outputArray.push(memory().subarray(pointer, pointer + dimensions.byteSize));
                        outputDimensions.push(dimensions);
                    }
                    model.transform(inputArray, inputDimensions, outputArray, outputDimensions);
                    return [2 /*return*/, id];
                });
            });
        },
        tfm_model_invoke: function (id, inputPtr, inputLen, outputPtr, outputLen) {
            deprecated("tfm_model_invoke()", "0.5");
        },
        tfm_preload_model: function (data, len, numInputs, numOutputs) {
            deprecated("tfm_preload_model()", "0.5");
        },
    };
    function synchroniseModelLoading() {
        return __awaiter(this, void 0, void 0, function () {
            var loadedModels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(pendingModels)];
                    case 1:
                        loadedModels = _a.sent();
                        pendingModels.length = 0;
                        loadedModels.forEach(function (_a) {
                            var id = _a[0], model = _a[1];
                            models[id] = model;
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        hostFunctions: { env: env },
        finaliseModels: synchroniseModelLoading,
    };
}
function counter() {
    var value = 0;
    return function () { value++; return value - 1; };
}
function isRuneExports(obj) {
    return (obj &&
        obj.memory instanceof WebAssembly.Memory &&
        obj._call instanceof Function &&
        obj._manifest instanceof Function);
}
function isStructuredLogMessage(obj) {
    return obj
        && typeof obj.level == 'string'
        && typeof obj.message == 'string'
        && typeof obj.target == 'string'
        && typeof obj.module_path == 'string'
        && typeof obj.file == 'string'
        && typeof obj.line == 'number';
}
exports.isStructuredLogMessage = isStructuredLogMessage;
//this function can convert any TypedArray to any other kind of TypedArray :
function convertTypedArray(src, constructor) {
    // Instantiate a buffer (zeroed out) and copy the bytes from "src" into it.
    var buffer = new constructor(src.byteLength);
    buffer.set(src.buffer);
    return buffer[0];
}
function deprecated(feature, version) {
    throw new Error("This runtime no longer supports Runes using \"".concat(feature, "\". Please rebuild with Rune ").concat(version));
}
function decodeValue(valueType, raw) {
    var buffer = raw.buffer, byteOffset = raw.byteOffset, byteLength = raw.byteLength;
    var bytes = buffer.slice(byteOffset, byteOffset + byteLength);
    switch (valueType) {
        case 1:
            var i32s = new Int32Array(bytes);
            return i32s[0];
        case 2:
            var f32s = new Float32Array(bytes);
            return f32s[0];
        case 5:
            return raw[0];
        case 6:
            var i16s = new Int16Array(bytes);
            return i16s[0];
        case 7:
            var i8s = new Int8Array(bytes);
            return i8s[0];
        default:
            throw new Error("Unknown value type, ".concat(valueType, ", with binary representation, ").concat(raw));
    }
}
